import { AWS_S3_RESUME_URL } from '@/constaint/route';
import moment from 'moment';
import * as Yup from 'yup';

export const formatFullDateTime = (date: string | Date) => {
  return moment(date).format('hh:mm A dd MMM yyyy');
};

export const formatHourMinute = (date: string | Date) => {
  return moment(date).format('hh:mm A');
};
export const formatDayMonthYear = (date: string | Date) => {
  return moment(date).format('dd MMM yyyy');
};

export const formatFullDayMonthYear = (date: string | Date) => {
  return moment(date).format('DD MMM YYYY');
};

export const formatMonthYear = (date: string | Date) => {
  const dateStr = moment(date).format('MMM YYYY');
  return dateStr !== 'Invalid date' ? dateStr : 'N/A';
};


export const getAvatar = (id?: string | number) => {
  const randomNumber = Math.floor(Math.random() * 1000000);

  return `https://api.dicebear.com/9.x/glass/svg?seed=${id ?? randomNumber}`;
};

export const formatString = (value: string) => {
  return value.toUpperCase();
};

export const formatSalary = (salary: number) => {
  return `${(salary / 1000).toFixed(0)}K`;
};

export const formatMoney = (amount: number): string => {
  const formattedAmount = amount.toLocaleString('en-US');
  return formattedAmount.endsWith('.00') ? formattedAmount.slice(0, -3) : formattedAmount;
};

export function formatCurrency(value: number): string {
  if (value >= 1_000_000_000) {
    return `${(value / 1_000_000_000).toFixed(1)}B`;
  } else if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  } else if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`;
    // } else if (value >= 1_00) {
    //   return `${(value / 1_00).toFixed(1)}L`;
  }
  return `${value.toFixed(0)}`;
}

export const isValidUrl = (url: string): boolean => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
    'i',
  );
  return urlPattern.test(url);
};

export const stripHTMLTags = (html: string): string => {
  return html
    .replace(/<br\s*\/?>/g, '\n')
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
};

export const replaceBullets = (text?: string): string | undefined => {
  if (!text) return text;

  const bulletRegex = /[●◉○◦]/g;

  return text.replace(bulletRegex, '•');
};


export const uppercaseFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const removeAccents = (str: string) => {
  return str
    .normalize("NFD") // Chuyển ký tự có dấu thành base + dấu
    .replace(/[\u0300-\u036f]/g, ""); // Xóa toàn bộ dấu
}


/**
 * Converts GPA from 4.0 scale to 10.0 scale
 * 
 * Formula: (GPA on 4.0 scale / 4) * 10
 * 
 * @param gpa GPA value on 4.0 scale
 * @returns Converted GPA on 10.0 scale, rounded to 2 decimal places
 */
export const convertGPAFrom4To10Scale = (gpa: number): number => {
  if (gpa < 0 || gpa > 4) {
    throw new Error('GPA must be between 0 and 4 on the 4.0 scale');
  }
  
  const convertedGPA = (gpa / 4) * 10;
  return Math.round(convertedGPA * 100) / 100; // Round to 2 decimal places
};


export const handleViewResume = (url: string, fileName: string) => {
  window.open(url, '_blank', `filename=${fileName}`);
};


// parse rich text editor fields
export const parseRichTextEditorFields = (value: any) => {
  if (!value) return value;

  // Kiểm tra nhiều loại định dạng dữ liệu từ rich text editor
  // Trường hợp 1: Nếu là object có thuộc tính htmlValue
  if (typeof value === 'object' && value !== null && 'htmlValue' in value) {
    return String(value.htmlValue || '').replace(/<p><br><\/p>/g, '');
  }
  
  // Trường hợp 2: Nếu là object có thuộc tính value
  if (typeof value === 'object' && value !== null && 'value' in value) {
    return String(value.value || '').replace(/<p><br><\/p>/g, '');
  }
  
  // Trường hợp 3: Nếu là object có thuộc tính html
  if (typeof value === 'object' && value !== null && 'html' in value) {
    return String(value.html || '').replace(/<p><br><\/p>/g, '');
  }
  
  // Trường hợp 4: Nếu là object nhưng không có các thuộc tính trên
  if (typeof value === 'object' && value !== null) {
    console.log('Rich text editor value format not recognized:', value);
    // Cố gắng chuyển đổi object thành JSON string
    try {
      return JSON.stringify(value);
    } catch (e) {
      // Nếu không thể chuyển đổi, trả về string rỗng
      return '';
    }
  }

  // Trường hợp còn lại: Là string hoặc loại dữ liệu khác
  return String(value).replace(/<p><br><\/p>/g, '');
};


// Helper function to handle rich text editor fields
export const createRichTextValidator = (fieldName: string, errorMessage: string) => {
  return Yup.string()
    .nullable()
    .transform((value) => (value === '' ? null : value))
    .transform((value) => {
      if (!value) return value;

      console.log('value', value, typeof value);
      // Extract htmlValue from editor object if it exists
      const editorValue = typeof value === 'object' && value !== null && 'htmlValue' in value
        ? value.htmlValue
        : value;
      return String(editorValue).replace(/<p><br><\/p>/g, '');
    })
    .test(fieldName, errorMessage, (value) => {
      if (!value) return true;
      return value.length > 0;
    });
};


export const generateResumeUrl = (resumeName: string) => {
  return resumeName?.includes('http') ? resumeName : `${AWS_S3_RESUME_URL}${resumeName}`;
};